import { Fragment, useContext, useEffect } from "react";
import { AppContext } from "../../App";
import "./style.css";

function CategoriesMenu2() {
	const { courses, getTranslatedString, category, setCategory, settings } = useContext(AppContext);
	const isOnePage = (settings.website.products_loading_type || "onepage") === "onepage";

	useEffect(() => {
		const handleResize = () => {
			const el = document.getElementsByClassName("categories-menu-2")[0];
			if (window.innerWidth < 900) el.style.display = "none";
			else el.style.display = "flex";
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window?.removeEventListener("resize", handleResize);
		};
	}, []);

	const scrollProducts = (category) => {
		console.log("scrollProducts");
		const scrollContainer = document.getElementById("main");
		const header = document.getElementById("header");
		const button = document.getElementById("categories-menu-2-button");
		const element = document.getElementById("category-" + category.id);
		if (!scrollContainer || !header || !element) return;

		const buttonHeight = button ? button.offsetHeight : 0;
		console.log(
			element.offsetTop,
			header.offsetHeight,
			buttonHeight,
			element.offsetTop - header.offsetHeight
		);
		scrollContainer.scrollTo({
			behavior: "smooth",
			top: element.offsetTop - header.offsetHeight - buttonHeight,
		});
	};

	const hideMenu = () => {
		const el = document.getElementsByClassName("categories-menu-2")[0];
		console.log(window.innerWidth);
		if (window.innerWidth < 900) el.style.display = "none";
	};

	return (
		<div className="categories-menu-2">
			<button className="close-button" onClick={hideMenu}>
				x
			</button>
			{courses.map((course, i) => (
				<Fragment key={i}>
					<div className="course">{getTranslatedString(course, "name")}</div>
					<div className="list">
						{course.categories.map(
							(c, n) =>
								c.products.length > 0 && (
									<button
										key={n}
										onClick={() => {
											if (isOnePage) scrollProducts(c);
											else setCategory(c);
											hideMenu();
										}}
										id={"category-button-" + c.id}
										className={category.id == c.id ? "active" : ""}
									>
										{settings.website.show_category_images == 1 && c.img && (
											<img className="category-icon" src={c.img} alt="" />
										)}
										{getTranslatedString(c, "name")}
									</button>
								)
						)}
					</div>
				</Fragment>
			))}
		</div>
	);
}

export default CategoriesMenu2;
